'use strict';

let MemberApp = angular.module('MemberApp');

MemberApp.controller('DocumentsCtrl', function(documentService, Upload, DocumentStore, userStore, otppConstants,
  $cookies, $scope, dispatcher, adobeAnalyticsService) {

  this.loadingState = DocumentStore.getLoadingStates();
  this.showDocumentSkeletonLoader = true;

  this.irn = userStore.getIrn();
  this.memberStatus = userStore.getMemberStatus();
  this.survivorPensioner = userStore.getSurvivorPensioner();
  this.apiUrl = otppConstants.apiUrl;
  this.token = $cookies.get(otppConstants.tokenStorageKey);

  this.documents = DocumentStore.getDocuments();
  this.requiredDocuments = DocumentStore.getRequiredDocuments();
  this.taxDocuments = DocumentStore.getTaxDocuments();
  this.taxDocumentsDocManager = DocumentStore.getTaxDocumentsDocManager();
  this.uploadedDocuments = DocumentStore.getUploadedDocuments();
  this.sizeOfUploadedDocuments = DocumentStore.getSizeOfUploadedDocuments();

  // Transitive UI state
  this.uploadingStatus = DocumentStore.getUploadingStatus();
  this.uploadSuccess = DocumentStore.getUploadSuccess();
  this.uploadFile = DocumentStore.getUploadFile();
  this.error = DocumentStore.getUploadError();
  this.downloadPending = DocumentStore.getDownloadPending();
  this.disableSubmit = true;
  this.taxDocsViewable = false;
  this.uploadProgress = DocumentStore.getUploadProgress();

  this.createDocument = (docFile) => {
    this.disableSubmit = true;
    dispatcher.dispatch('document:setUploadingStatus', false);
    dispatcher.dispatch('document:setUploadError', {});
    dispatcher.dispatch('document:setUploadingStatus', true);
    dispatcher.dispatch('document:setUploadProgress', 0);

    dispatcher.dispatch('document:setUploadFile', {
      name: docFile.name,
      size: docFile.size / (1024 * 1024),
      type: docFile.type
    });

    documentService.createDocument(docFile).then((response) => {
      if (response.status === 200) {
        dispatcher.dispatch('document:setUploadSuccess', true);
        dispatcher.dispatch('document:setUploadingStatus', false);
      } else {
        dispatcher.dispatch('document:setUploadError', {message: `doc.centre.upload.error.${response.status}`});
        dispatcher.dispatch('document:setUploadingStatus', false);
      }
    }).catch((error) => {
      dispatcher.dispatch('document:setUploadError', {message: `doc.centre.upload.error.${error.status}`});
      dispatcher.dispatch('document:setUploadingStatus', false);
      adobeAnalyticsService.trackDocCentreUploadError();
    });
  };

  this.requiredDocsViewable = () => {
    return this.memberStatus === 'member';
  };

  this.hasTaxDocs = () => {
    if (this.taxDocuments !== undefined && this.taxDocumentsDocManager !== undefined) {
      return this.taxDocuments.length > 0 || this.taxDocumentsDocManager.length > 0;
    }
  };

  this.newFile = (file) => {
    dispatcher.dispatch('document:setUploadError', {});
    dispatcher.dispatch('document:setUploadingStatus', false);
    dispatcher.dispatch('document:setUploadSuccess', false);

    if (file === undefined) {
      return;
    }

    if (file.$error !== undefined) {
      this.disableSubmit = true;
      dispatcher.dispatch('document:setUploadError', {message: 'doc.centre.upload.error.' + file.$error});
      adobeAnalyticsService.trackDocCentreUploadError();
    } else {
      this.disableSubmit = false;
    }
  };

  this.downloadGeneralDocument = (documentId, description) => {
    if (!this.downloadPending) {
      documentService.downloadGeneralDocument(documentId, description);
    }
  };

  this.downloadUploadedDocument = (documentId, description) => {
    if (!this.downloadPending) {
      documentService.downloadUploadedDocument(documentId, description);
    }
  };

  this.downloadTaxDocument = (year, type) => {
    if (!this.downloadPending) {
      documentService.downloadTaxDocument(year, type);
    }
  };

  this.downloadTaxDocumentDocManager = (documentId, description) => {
    if (!this.downloadPending) {
      documentService.downloadTaxDocumentDocManager(documentId, description);
    }
  };

  this.getDocumentType = (doc) => {
    var extension = doc.description.split('.').pop().toLowerCase();
    if (extension === 'pdf') {
      return 'pdf';
    } else if (extension === 'png') {
      return 'icon-png';
    }
    else {
      return 'image';
    }
  };

  this.enterOnFocus = ($event, doc) => {
    if (event.key === 'Enter') {
      this.downloadUploadedDocument(doc.id, doc.description);
    }
  };

  this.getDocStyle = (doc) =>
  {
    if (doc.type === 'SPOUSAL_WAIVER' &&
      ((!doc.received && !doc.penAppSubmitted) || (doc.received && !doc.penAppSubmitted && doc.memberUnder72))) {
      return 'important';
    }
    return doc.received ? 'received' : 'outstanding';
  };

  let documentStoreSubscription = DocumentStore.onUpdate('DocumentsCtrl', () => {
    this.loadingState = DocumentStore.getLoadingStates();
    this.documents = DocumentStore.getDocuments();
    this.requiredDocuments = DocumentStore.getRequiredDocuments();
    this.taxDocuments = DocumentStore.getTaxDocuments();
    this.taxDocumentsDocManager = DocumentStore.getTaxDocumentsDocManager();
    this.uploadedDocuments = DocumentStore.getUploadedDocuments();
    this.sizeOfUploadedDocuments = DocumentStore.getSizeOfUploadedDocuments();

    this.uploadingStatus = DocumentStore.getUploadingStatus();
    this.uploadSuccess = DocumentStore.getUploadSuccess();
    this.uploadFile = DocumentStore.getUploadFile();
    this.error = DocumentStore.getUploadError();

    this.uploadProgress = DocumentStore.getUploadProgress();

    this.downloadPending = DocumentStore.getDownloadPending();
    this.taxDocsViewable = this.memberStatus === 'pensioner' || this.survivorPensioner || this.hasTaxDocs();

    if (this.showDocumentSkeletonLoader) {
        setTimeout(() => {
            this.showDocumentSkeletonLoader = false;
            $scope.$apply();
        }, 2000);
    } 
  
  }, false, true);

  let userStoreSubscription = userStore.onUpdate('DocumentsCtrl', () => {
    this.irn = userStore.getIrn();
    this.memberStatus = userStore.getMemberStatus();
    this.survivorPensioner = userStore.getSurvivorPensioner();
  }, false, false);

  $scope.$on('$destroy', function() {
    dispatcher.dispatch('document:clearUploadStatus');
    DocumentStore.deregister(documentStoreSubscription);
    userStore.deregister(userStoreSubscription);
  });
});
